import { styles } from './styles';
import { button } from './components/button';
import { heading } from './components/heading';
import { tag } from './components/tag';
import { text } from './components/text';
import { extendTheme } from '@chakra-ui/react';
import Vendor from '../vendor.config';
import { Color } from './color';
import { convertSnakeToCamelCase } from '../utils/parser';

const colors = Object.keys(Color).reduce(
	(accumulator, key) => ({
		...accumulator,
		[convertSnakeToCamelCase(key)]: Color[key as keyof typeof Color],
	}),
	{}
);

export const customTheme = extendTheme({
	fonts: {
		heading: 'Sora, sans-serif',
		body: 'Sora, sans-serif',
	},
	config: {
		initialColorMode: Vendor.gui.theme,
	},
	styles,
	textStyles: {
		uppercase: {
			textTransform: 'uppercase',
		},
	},
	colors: {
		...colors,
		action: Color.ACTION,
		accept: Color.TEST_GREEN,
		accentSubtle: Color.BACKGROUND_LIGHT,
	},
	components: {
		Heading: heading,
		Button: button,
		Text: text,
		Tag: tag,
		Box: {
			bg: 'yellow !important',
		},
	},
	breakpoints: {
		sm: '480px',
		md: '768px',
		lg: '992px',
		hashup: '1168px',
		xl: '1280px',
		'2xl': '1536px',
	},
});
